import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "@/components/ui/sonner";
import { api } from "@/api";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mellowj_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [checkingOut, setCheckingOut] = useState(false);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    localStorage.setItem("mellowj_cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => ({
    items,
    open,
    setOpen,
    checkingOut,
    promo,
    setPromo,
    addItem(item) {
      setItems((current) => {
        if (current.some((entry) => entry.item_type === item.item_type && entry.item_id === item.item_id)) {
          toast.info("Already in your selection");
          return current;
        }
        toast.success("Added to your collection");
        return [...current, item];
      });
      setOpen(true);
    },
    removeItem(item) {
      setItems((current) => current.filter((entry) => !(entry.item_type === item.item_type && entry.item_id === item.item_id)));
    },
    clear() { setItems([]); setPromo(null); },
    async checkout(email) {
      setCheckingOut(true);
      try {
        const response = await api.post("/payments/checkout", {
          items: items.map(({ item_type, item_id }) => ({ item_type, item_id })),
          email: email || undefined,
          promo_code: promo?.code || undefined,
          origin_url: window.location.origin,
        });
        localStorage.setItem("mellowj_pending_cart", JSON.stringify(items));
        window.location.href = response.data.checkout_url;
      } finally {
        setCheckingOut(false);
      }
    },
  }), [items, open, checkingOut, promo]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
